// import { PurchaseChannel } from "./draft-registration";
import { CustomerPortalVersion } from "@redotech/redo-customer-portal-common/customer-portal-version";
import { RegistrationRewardType } from "./extended-warranty";

export enum PurchaseChannel {
  RETAIL = "retail",
  ONLINE = "online",
}

export const CHANNEL_NAME_PARAM = "channelName";

export enum RepairFeeCollectionStrategy {
  INSTANT = "instant",
  DEFERRED = "deferred",
}

export enum RetailAction {
  REGISTER_PRODUCT = "register_product",
  FILE_CLAIM = "file_claim",
  START_RETURN = "start_return",
}

/**
 * Keep in sync with the generated `WarrantiesSettings` Raw type in
 * `redo/backend/db/schema/src/team/WarrantiesSettings.ts`.
 */
export interface WarrantiesSettings {
  enabled: boolean;
  labelCoverageEnabled: boolean;
  /**
   * @deprecated use purchaseChannelRegistrationCollection instead
   */
  warrantyRegistrationCollection?: string;
  purchaseChannelRegistrationCollection?: {
    collectionId: string | undefined;
    purchaseChannel: PurchaseChannel;
  }[];
  customersCanStartClaims: boolean;
  registrationEnabled: boolean;
  redirectRegistrationToRetailActions: boolean;
  useWTYPrefixForRetail: boolean;
  registrationRewardType?: RegistrationRewardType;
  registrationCustomerTags?: string[];
  portalFourRegistration: boolean;
  redirectPostRegistration?: string;
  registrationRewardDiscountId?: string;
  sendDefaultEmail: boolean;
  triggerMarketingFlow: boolean;
  hideItemPricing: boolean;
  showOtherOption: boolean;
  cantFindItemButtonEnabled?: boolean;
  mailingListSignUpEnabled?: boolean;
  requirePhoneNumber?: boolean;
  askShopperForPricePaid?: boolean;
  purchaseChannels: { displayName: string; purchaseChannel: PurchaseChannel }[];
  eligibleUpsellTypes?: PurchaseChannel[];
  enabledRetailActions?: RetailAction[];
  allowQuantitySelect?: boolean;
  maxQuantitySelect?: number;
}

const VALID_CUSTOMER_PORTAL_VERSIONS = [CustomerPortalVersion.V4_0];

export function shouldShowWarrantyButton(
  customerPortalVersion?: CustomerPortalVersion,
  customersCanStartClaims?: boolean,
) {
  if (!customerPortalVersion || !customersCanStartClaims) {
    return false;
  }
  return (
    VALID_CUSTOMER_PORTAL_VERSIONS.includes(customerPortalVersion) &&
    customersCanStartClaims
  );
}

export function getRegistrationCollectionIds(
  settings:
    | {
        purchaseChannelRegistrationCollection?:
          | { collectionId?: string | null; purchaseChannel: PurchaseChannel }[]
          | null;
      }
    | null
    | undefined,
  purchaseChannel: PurchaseChannel,
): string[] {
  return (
    settings?.purchaseChannelRegistrationCollection
      ?.filter(
        (collection) =>
          collection.purchaseChannel === purchaseChannel &&
          collection.collectionId != null,
      )
      .map((collection) => collection.collectionId!) ?? []
  );
}

export function getRegistrationCollectionId(
  settings:
    | {
        purchaseChannelRegistrationCollection?:
          | { collectionId?: string | null; purchaseChannel: PurchaseChannel }[]
          | null;
        warrantyRegistrationCollection?: string | null;
      }
    | null
    | undefined,
  purchaseChannel: PurchaseChannel,
): string | null | undefined {
  const matchingCollectionId =
    settings?.purchaseChannelRegistrationCollection?.find(
      (collection) => collection.purchaseChannel === purchaseChannel,
    )?.collectionId;

  return matchingCollectionId ?? settings?.warrantyRegistrationCollection;
}
